import type { ShopOwnerRef, ShopStatus, ShopType } from '../../api/types.ts';

export interface SelectOption<T extends string> {
  value: T;
  label: string;
}

export const SHOP_TYPE_OPTIONS: SelectOption<ShopType>[] = [
  { value: 'live', label: 'Live' },
  { value: 'demo', label: 'Demo' },
  { value: 'training', label: 'Training' },
];

/** MUI Chip `color` for a shop status: active=green, suspended=amber, disabled=red. */
export function statusChipColor(status: ShopStatus): 'success' | 'warning' | 'error' {
  if (status === 'active') return 'success';
  if (status === 'suspended') return 'warning';
  return 'error';
}

export function statusLabel(status: ShopStatus): string {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

/** The three-way status control's captions -- what each option DOES, shown
 *  next to the option and in the confirm dialog body. */
export const STATUS_CAPTIONS: Record<ShopStatus, string> = {
  active: 'syncs and receives licences',
  suspended: 'uploads accepted, licence WITHHELD - shop stops trading when its current licence expires',
  disabled: 'auditor requests rejected; an already-issued offline licence remains valid until its expiry',
};

export const STATUS_ORDER: ShopStatus[] = ['active', 'suspended', 'disabled'];

export const SHOP_STATUS_OPTIONS: SelectOption<ShopStatus>[] = STATUS_ORDER.map((status) => ({
  value: status,
  label: statusLabel(status),
}));

/** Comma-joined "First Last" list for the shops table's Owners column. */
export function ownersDisplayText(owners: ShopOwnerRef[]): string {
  if (owners.length === 0) return '-';
  return owners.map((o) => `${o.first_name} ${o.last_name}`.trim()).join(', ');
}

/** True when |skew| exceeds one minute -- the detail panel highlights this. */
export function isClockSkewWarning(skewMs: number | null): boolean {
  return skewMs !== null && Math.abs(skewMs) > 60_000;
}
